import useDictStore from '@/store/modules/dict'
import { getDicts } from '@/modules/huyu-framework/backend/api/system/dict/data'
import { ref, toRefs } from 'vue'

/**
 * 获取字典数据
 */
export function useDict(...args) {
  const res = ref({});
  return (() => {
    args.forEach((dictType, index) => {
      res.value[dictType] = [];
      const dicts = useDictStore().getDict(dictType);
      if (dicts) {
        res.value[dictType] = dicts;
      } else {
        getDicts(dictType).then(resp => {
          if (resp.code === 200 && resp.rows) {
            res.value[dictType] = resp.rows.map(p => ({ label: p.dictLabel, value: p.dictValue, elTagType: p.listClass, elTagClass: p.cssClass }))
            useDictStore().setDict(dictType, res.value[dictType]);
          }
        })
      }
    })
    return toRefs(res.value);
  })()
}